import AppSettings from 'es/core/AppSettings';

export interface ILocale {
    id: string;
    name: string;
}

export class Locale implements ILocale {
    public constructor(
        public readonly id: string,
        public readonly name: string,
        public readonly localizedName: string) {
    }

    public toString() {
        return this.name;
    }
}

const availableLocals = [
    new Locale('zh', 'Chinese (simplified)', '中文'),
    new Locale('en', 'English', 'English'),
    new Locale('fr', 'French', 'Français'),
    new Locale('es', 'Spanish', 'Español'),
    new Locale('vi', 'Vietnamese', 'Tiếng Việt'),
    new Locale('lt', 'Lithuanian', 'Lietuvis'),
];

const explicitlyAllowedLocals = (AppSettings.languagesExplicitlyAllowed || '')
    .split(',')
    .filter(code => code !== '')
    .map(code => code.trim().toLowerCase());

// Either an explicit set of allowed languages is supplied, or we allow all supported
export const PREFERRED_LOCALES = explicitlyAllowedLocals.length === 0 ?
    availableLocals :
    availableLocals.filter(l => explicitlyAllowedLocals.indexOf(l.id) !== -1);

export const DEFAULT_LOCALE = explicitlyAllowedLocals[0] || 'en';
